(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SmartTerminal", [], factory);
	else if(typeof exports === 'object')
		exports["SmartTerminal"] = factory();
	else
		root["SmartTerminal"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!./../node_modules/css-loader/index.js?importLoaders=1,url=false!./../node_modules/postcss-loader/index.js!./index.pcss", function() {
			var newContent = require("!!./../node_modules/css-loader/index.js?importLoaders=1,url=false!./../node_modules/postcss-loader/index.js!./index.pcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "/*\nbased on https://github.com/cssrecipes/custom-media-queries/blob/master/index.css\n */\n:root {\n\n  /*dark theme*/\n}\n@font-face {\n  font-family: 'Droid Sans Mono';\n  src: url('https://fonts.googleapis.com/css?family=Droid+Sans+Mono'); /* IE9 Compat Modes */\n}\n.smart-terminal {\n  font-family: 'Droid Sans Mono', monospace;\n  background-color: #06071a;\n  border-radius: 2px;\n  border: 1px solid #04bbff;\n  position: fixed;\n  z-index: 1;\n  right: 10px;\n  bottom: 10px;\n  margin-left: 10px;\n  color: #fff;\n  padding: 1em;\n  font-size: 10px;\n  -webkit-transition: all 1000ms ease;\n  transition: all 1000ms ease;\n}\n.smart-terminal[data-minimised=\"true\"] {\n  height: 10px;\n  background: none;\n  border: 0 solid #476c80;\n}\n.smart-terminal[data-minimised=\"true\"]:before {\n  display: block;\n}\n.smart-terminal[data-minimised=\"true\"] .content {\n  display: none;\n}\n.smart-terminal:before {\n  display: none;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  color: #20eb00;\n  font-size: 12px;\n  content: \"\\1F4E1\";\n}\n.smart-terminal[data-pending=\"true\"]:before {\n  font-size: 30px;\n  -webkit-animation-name: spin;\n          animation-name: spin;\n  -webkit-animation-duration: 2000ms;\n          animation-duration: 2000ms;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  -webkit-transition: all 300ms ease;\n  transition: all 300ms ease;\n}\n.smart-terminal[data-pending=\"true\"]:after {\n  content: \"\";\n  display: block;\n  border: 2px solid #fff;\n  -webkit-border-radius: 50%;\n  height: 50px;\n  width: 50px;\n  position: absolute;\n  left: -18px;\n  top: -18px;\n  -webkit-animation: pulsate 1s ease-out;\n  -webkit-animation-iteration-count: 1;\n  -webkit-animation-delay: 0.2s;\n  opacity: 0.0;\n}\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotateY(0deg);\n            transform: rotateY(0deg);\n  }\n  to {\n    -webkit-transform: rotateY(360deg);\n            transform: rotateY(360deg);\n  }\n}\n@keyframes spin {\n  from {\n    -webkit-transform: rotateY(0deg);\n            transform: rotateY(0deg);\n  }\n  to {\n    -webkit-transform: rotateY(360deg);\n            transform: rotateY(360deg);\n  }\n}\n@-webkit-keyframes pulsate {\n  0% {\n    -webkit-transform: scale(0.1, 0.1);\n    opacity: 0.0;\n  }\n  50% {\n    opacity: 1.0;\n  }\n  100% {\n    -webkit-transform: scale(6, 6);\n    opacity: 0.0;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(0);
var times = { SHORT_TIME: 6000 };
/**
 * Shows messages tp user
 * @constructor
 */
var SmartTerminal = (function () {
    function SmartTerminal(contentFunction, onDestroyFunction) {
        this.timeTillCloseAfterAppending = times.SHORT_TIME;
        this.pulseTypeNext = false;
        this.hostElement = document.createElement('article');
        this.hostElement.title = "Hello, I will inform you of anything you need to know during your visit on this site.";
        this.hostElement.innerHTML =
            "<div class=\"content\">\n     </div>";
        this.contentElement = this.hostElement.querySelector('.content');
        this.hostElement.className = 'smart-terminal';
        this.minimise();
    }
    SmartTerminal.prototype.show = function () {
        document.body.appendChild(this.hostElement);
    };
    SmartTerminal.prototype.revealForDuration = function () {
        this.hostElement.dataset["minimised"] = "false";
        setTimeout(function () {
            this.minimise();
        }.bind(this), this.timeTillCloseAfterAppending);
    };
    SmartTerminal.prototype.appendMessages = function (messages) {
        var _this = this;
        this.clear();
        this.stopPending();
        messages.forEach(function (message) {
            _this.contentElement.innerHTML += "<p>" + message + "</p>";
        });
    };
    SmartTerminal.prototype.appendMessage = function (message) {
        this.clear();
        this.stopPending();
        var contentEl = this.hostElement.querySelector('.content');
        this.contentElement.innerHTML += "<p>" + message + "</p>";
        this.revealForDuration();
    };
    SmartTerminal.prototype.setTimeTillCloseAfterAppending = function (time) {
        this.timeTillCloseAfterAppending = time;
        return this;
    };
    SmartTerminal.prototype.minimise = function () {
        this.hostElement.dataset["minimised"] = "true";
        return this;
    };
    SmartTerminal.prototype.clear = function () {
        this.contentElement.innerHTML = '';
        this.minimise();
        return this;
    };
    /**
     * Makes the satellite icon spin, tells the user something is happening.
     */
    SmartTerminal.prototype.startPending = function () {
        this.hostElement.dataset["pending"] = 'true';
        return this;
    };
    /**
     * Makes the satellite icon stop spinning
     */
    SmartTerminal.prototype.stopPending = function () {
        this.hostElement.dataset["pending"] = 'false';
        return this;
    };
    SmartTerminal.prototype.destroy = function () {
        this.hostElement.parentElement.removeChild(this.hostElement);
    };
    return SmartTerminal;
}());
SmartTerminal.EVENTS = {
    APPEND_MESSAGE: "APPEND_MESSAGE",
    APPEND_MESSAGES: "APPEND_MESSAGES",
    START_PENDING: "START_PENDING"
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SmartTerminal;


/***/ })
/******/ ]);
});
//# sourceMappingURL=smart-terminal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/smart-terminal/build/smart-terminal.js
// module id = 96
// module chunks = 0